import 'whatwg-fetch';

import Component from '../site/Component';
import Cookies from '../utilities/Cookies';

/**
 * Component for Newsletters component.
 */
export default class Newsletters extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    Array.prototype.forEach.call(
      this.element.querySelectorAll(this.elements.submit),
      (el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const action = 'hachette_mailchimp_subscribe';
          const requestBody = [].slice.call(
              this.element.querySelectorAll(this.elements.input)
            )
            .reduce(
              (body, field) => `${body}&${field.name}=${field.value}`,
              `action=${action}&nonce=${window.newsletter.nonce}&subscriptionSourceURL=${window.location.href}`
            );

          const popupEmail = document.getElementById('mce-EMAIL');
          const emailInput =
            requestBody.split('email_address=')[1].split('&')[0];
          const submit = this.element.querySelector(this.elements.submit);
          const email = this.element.querySelector(this.elements.email);
          if (submit) {
            submit.disabled = true;
          }

          fetch(window.newsletter.ajax_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;',
            },
            credentials: 'include',
            body: requestBody,
          })
            .then((data) => data.json())
            .then((response) => {
              const text = this.element.querySelector(this.elements.text);
              const chimpPopup =
                document.getElementById('mailchimp_options_popup');
              if (response.results) {
                if ('duplicate' === response.results) {
                  text.textContent = window.newsletter.duplicate;
                  // If Mailchimp popup is present, show it and add user email.
                  if (popupEmail && chimpPopup) {
                    popupEmail.value = emailInput;
                    chimpPopup.classList.add('show');
                  }
                } else if ('success' === response.results) {
                  text.textContent = window.newsletter.success;
                  let cookie = new Cookies();
                  cookie.setCookie('brazeUser', emailInput, 90);
                  
                  // Same as above, popup is only present for HBG default list.
                  if (popupEmail && chimpPopup) {
                    popupEmail.value = emailInput;
                    chimpPopup.classList.add('show');
                  }
                } else if ('invalid' === response.results) {
                  text.textContent = window.newsletter.invalid;
                } else {
                  text.textContent = window.newsletter.error;
                }
              } else {
                text.textContent = window.newsletter.error;
              }
              submit.disabled = false;

              if (
                'undefined' !== typeof response.results
                && 'success' !== response.results
                && 'function' === typeof email.select
              ) {
                email.select();
                email.focus();
              }
            });
        });
      }
    );
  }
}

jQuery(document).ready(function () {
	jQuery("#braze-subscribe-form").submit(function (event) {
    event.preventDefault();
		let genresInputs = [];

    jQuery(".genreCheckbox:checked").each(function(){
			genresInputs.push(jQuery(this).val().toLowerCase());
		});

    let preferredRetailer = [];
    jQuery(".preferred-retailer-checkbox:checked").each(function(){
			preferredRetailer.push(jQuery(this).val());
		});

    let newsletterGroupInputs = [];
    jQuery(".newsletterGroupCheckbox:checked").each(function(){
			newsletterGroupInputs.push(jQuery(this).val());
		});

    let list_id = jQuery("#hachette_newletter_list_id").val() ?? false;

    let subscription_groups = [];
    if(list_id){
      subscription_groups = [list_id];
    } else {
      jQuery(".pageEdcConfNewsletterGroupCheckbox:checked").each(function(){
        subscription_groups.push(jQuery(this).val());
      });
    }

    let nonceVal = window.newsletter.nonce;
	  let formData = {
      'email_address': jQuery("#braze-EMAIL").val(),
      'list_id': subscription_groups,
      'genres': genresInputs,
      'preferredRetailer': preferredRetailer,
      'newsletterGroups': newsletterGroupInputs,
      'action': 'hachette_mailchimp_subscribe',
      'nonce': nonceVal,
      'subscriptionSourceURL' : window.location.href,
	  };
    if ( list_id ) {
      formData.list_id = list_id;
    }

	  jQuery.ajax({
      type: "POST",
      url: window.newsletter.ajax_url,
      data: formData,
	  }).done(function (data) {
      if(data.results) {
        jQuery('#email_subscribe_button').hide();
        if(jQuery('#failure_msg').length) {
          jQuery('#failure_msg').hide();
        }
        if(jQuery('#succes_msg')) {
          jQuery('#succes_msg').show();
        }
        let cookie = new Cookies();
        cookie.setCookie('brazeUser', formData.email_address, 90);
      } else {
        jQuery('#email_subscribe_button').show();
        if(jQuery('#failure_msg').length) {
          jQuery('#failure_msg').show();
        }
        if(jQuery('#succes_msg')) {
          jQuery('#succes_msg').hide();
        }
      }
    });
  });
  });
